import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="transparent" {...props}>
    <path
      d="M10.1144 4.66667L5.72385 9.05719C5.20315 9.57789 5.20315 10.4221 5.72385 10.9428C6.24455 11.4635 7.08877 11.4635 7.60947 10.9428L11.8856 6.55228C12.927 5.51089 12.927 3.82245 11.8856 2.78105C10.8442 1.73965 9.15577 1.73965 8.11437 2.78105L3.83823 7.17157C2.27613 8.73367 2.27613 11.2663 3.83823 12.8284C5.40033 14.3905 7.93299 14.3905 9.49508 12.8284L13.6667 8.66667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
